<template>
  <div class="collectDevice">
    <el-container>
      <el-header >
        <span style="font-size: 24px;">成蹊IOT物联网服务器</span>
      </el-header>
      <el-main style="margin:0px;padding:0px;">
        <el-row>
          <span style="font-size: 20px;">应用场景</span>
          <p>物联网（IoT）是帮助人工智能（AI）以更好的方式控制和理解事物的高新技术。成蹊IOT物联网服务器能解决：对下支持各个业务领域智能感知设备接入，对上可以支撑各类物联网应用业务数据获取或下行控制。如下图所示</p>
        </el-row>
        <el-row>
          <img width="700px" height="200px" src="@/assets/image/iot_server.png">
        </el-row>
        <el-row>
          <img width="1000px" height="500px" src="@/assets/image/iot_platform.png">
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'networkDevicePage'
}
</script>

<style lang="less" scoped>
body {
  margin: 0px;
}
.el-row {
  margin-top: 10px;
  padding-top: 10px;
}
</style>
